/**
 * Shared constants for the document management module.
 * Define once here — import everywhere — no more string literals scattered across files.
 */

// Google Drive MIME types
export const FOLDER_MIME_TYPE = 'application/vnd.google-apps.folder';

// Root folder
export const ROOT_FOLDER_KEY = 'root';
export const ROOT_FOLDER_LABEL = 'Project Files';

// Display
export const EMPTY_CELL = '—';

// Document cache — 30 min in-memory TTL for file lists.
// Background revalidation on every folder open means users always get fresh data
// while never seeing a blank screen on revisit.
export const DOCUMENT_CACHE_DURATION_MS = 30 * 60 * 1000; // 30 minutes
export const DOCUMENT_FOLDER_PAGE_SIZE = 200;

// Virtual list
export const VIRTUALIZER_OVERSCAN = 6;
export const ROW_HEIGHT = {
  desktop: 44,
  desktopWithLocation: 56,
  // Mobile rows are tall enough for a gloved finger to clear the row
  // edges without mis-tapping the cloud / divider — 64pt matches Apple
  // Files at 100% Display Zoom and sits above the 44pt HIG minimum.
  mobile: 64,
} as const;
